export default __webpack_public_path__ + "static/media/feedback.9f9fa0b5.png";